<template>
  <div class="campaigns">
    <div class="inner-content">
      <Alert></Alert>

      <v-row class="campaigns-list mt-5">
        <Card
          v-for="campaign in campaigns"
          :key="`campaign-${campaign.id}`"
          :title="campaign.title.rendered"
          :link="{ name: 'campaign-info', params: {slug: decodeURIComponent(campaign.slug)} }"
          :image="campaign.icon"
          dark
        ></Card>
      </v-row>

      <h3 v-if="campaigns.length === 0 && !loading">Не бяха намерени актуални кампании.</h3>

      <v-btn color="primary" class="mt-5 mb-5" to="/предложи-кампания" v-if="loggedIn">
          Предложи кампания <v-icon class="ml-3">send</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Alert from '@/components/Utils/Alert.vue'
import Card from '@/components/Card.vue'

export default {
  name: 'CampaignsList',
  components: { Alert, Card },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getCampaigns').then(() => {
      this.$store.commit('setLoading', false)
    }).catch(() => {
      this.$store.commit('showAlert', { type: 'error', message: 'Грешка при зареждането на кампаниите.' })
      this.$store.commit('setLoading', false)
    })
  },

  computed: mapGetters(['loggedIn', 'campaigns', 'loading']),
}
</script>
